/**
 * dev  : zhihuaw
 * desc : 榜单聚合页model层组件
 * props: compProps、payLoad、compIndex
 * emit : init：初始化数据；finish：数据改变触发
 */
<template>
  <div></div>
</template>
<script>
/* eslint-disable */
import { fetchHouseIds,fetchHouseDetail } from '@/services/list'
import { errorReport } from '@/utils/index.js'
import tujialogin from '@/utils/tujialogin.js'

export default {
  mixins: [tujialogin],
  components: {
  },
  data() {
    return {
      // 榜单中房屋数据
      houseData: [],
      // 房屋收藏关注数和状态
      // favorFocus: null,
      // 防止重复点击收藏
      // isClick: false
    }
  },
  props: {
    /**
     * [detail主接口comProps属性数据]
     */
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    /**
     * [组件所需数据体]
     */
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    },
    /**
     * [组件索引]
     */
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    /**
     * [payload改变]
     * TODO: 调用收藏接口/去往cms详情页
     */
    payLoad(newVal){
      if(newVal.type==='location'){
        this.gotoDetail(newVal.data)
      }
    }
  },
  methods: {
    /**
     * [榜单初始化方法]
     */
    async init() {
      // 通过榜单id获取房屋id，
      const ids = [this.compProps.mate.activityId]
      const labelRes = await fetchHouseIds({ ids })
      
      if (labelRes.ret && labelRes.data) {
        this.houseData=labelRes.data[0].houseData
        
        try{
          const houseIdList=[]

          this.houseData.forEach((item,index)=>{
            // 只查询cms榜单中的前10个房屋详情（查询太多，时效太长）
            if(index<=1){
              houseIdList.push(item.id)
            }
          })
          // 无需报价
          const noNeedPrice=true
          // 展示下架房屋
          const needUnactive=true
          // 展示无库存
          const needNoRepositoty=true
          // 通过房屋id获取房屋详情
          const houseRes=await fetchHouseDetail({houseIdList,noNeedPrice,needUnactive,needNoRepositoty})
          
          if (houseRes.ret && houseRes.data) {
            const houseList=houseRes.data.items
            
            houseList.forEach((item,index)=>{
              const idx=houseIdList.indexOf(item.unitId.toString())
              
              if(idx>-1){
                this.houseData[idx].defaultPicture=item.pictureList?item.pictureList[0]:item.defaultPicture
                this.houseData[idx].unitName=item.unitName
              }
            })
          }
          this.$emit('init',this.houseData)
          // 检查房屋收藏状态，不必优先请求
          // this.checkFavorAndFocus()
        } catch (e) {
          console.log(e)
          errorReport(e)
        }
      }
    },
    /**
     * [榜单收藏状态和关注数接口方法] 下掉
     */
    // checkFavorAndFocus() {
    //   // 通过榜单id获取房屋id，
    //   const activityId=this.compProps.mate.activityId
    //   const activityIdList = [activityId]
    //   const favoriteItemType=5
    //   const virtureType=1
    //   let fetchFavor=null

    //   if(!this.$root.isLogin){
    //     fetchFavor=Promise.resolve(false)
    //   }else{
    //     fetchFavor=checkFavorite({activityIdList}).then((ret)=>{
    //       if (ret && ret.errcode === 0) {
    //         if(ret.data.favoritedActivitys&&ret.data.favoritedActivitys.length>0){
    //           return true
    //         }else{
    //           return false
    //         }
    //       } else{
    //         return false
    //       }
    //     })
    //     .catch((err)=>{})
    //   }
      
    //   const getFocus=getFavoriteAndFocus({activityIdList,favoriteItemType,virtureType}).then((ret)=>{
    //     if (ret && ret.errcode === 0) {
    //       const result={}
    //       if(ret.data.mapCount){
    //         result.favorCount=ret.data.mapCount[activityId]
    //       }else{
    //         result.favorCount=0
    //       }
    //       if(ret.data.attentionCount){
    //         result.focusCount=ret.data.attentionCount[activityId]
    //       }else{
    //         result.focusCount=0
    //       }
    //       return result
    //     } else{
    //       return {favorCount:0,focusCount:0}
    //     }
    //   })
    //   .catch((err)=>{})
      
    //   Promise.all([fetchFavor, getFocus])
    //   .then((data) => {
    //     this.favorFocus=data[1]||{favorCount:0,focusCount:0}
    //     this.favorFocus.favorState=data[0]
    //   })
    //   .catch((e) => {
    //     this.favorFocus.favorState=false
    //     this.favorFocus.focusCount=0
    //     this.favorFocus.favorCount=0
    //   })
    //   .finally(()=>{
    //     this.$emit('finish', this.favorFocus)
    //   })
    // },
    /**
     * [去往cms详情页]
     * @param val 关于cmsid，like的数据集合
     */
    gotoDetail(val){
      window.location.href=`${process.env.VUE_APP_M_TUJIA_HOST}/modules/?id=${val.activityId}`
    },
    // 透传子servComp组件finish事件到UiComp组件
    finishHandle(payLoad) {
      this.$emit('finish', payLoad);
    }
  }
}
</script>
